<template>
  <div
    class="football_cup_cardList"
    :class="{ unClickDetail: unClickDetailMode }"
  >
    <span class="card_item" v-for="group in list" :key="group.key">
      <span class="cardItem_topBg"></span>
      <span class="cardItem_main">
        <span class="cardItem_main_title" v-text="group.title"></span>
        <span
          class="theme_publishBtn"
          @click="clickPublish(mode, group)"
          v-if="mode == 'overviewTeamData' || mode == 'overviewPlayerData'"
        >
          <svg
            t="1692698307306"
            class="publishBtn_icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="9670"
            width="50%"
            height="50%"
          >
            <path
              d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
              p-id="9671"
            ></path>
          </svg>
        </span>
        <slot
          v-if="mode == 'overviewTeamData'"
          name="overviewTeamData"
          :datas="group.datas"
        >
          <!-- <span>overviewTeamData</span> -->
        </slot>
        <slot
          v-else-if="mode == 'overviewPlayerData'"
          name="overviewPlayerData"
          :datas="group.datas"
        >
          <!-- <span>overviewPlayerData</span> -->
        </slot>
        <slot v-else>
          <span
            class="cardItem_row"
            v-for="item in group.datas"
            :key="item.id"
            @click="goDetail(item, mode)"
          >
            <span class="cardItem_row_image">
              <img :src="item.imageUrl" />
            </span>
            <span class="cardItem_row_text" v-text="item.shortName"></span>
          </span>
        </slot>
      </span>
    </span>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'football_cup_cardList',
  mixins: [cup_base_data_mixin],
  props: {
    mode: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => {
        return [
          // {
          //   title: val.seriesName,
          //   key: val.seriesCode,
          //   datas: val.datas.map((item) => ({
          //     imageUrl: item.teamLogo,
          //     id: item.teamId,
          //     shortName: item.shortName,
          //   })),
          // },
        ]
      },
    },
  },
  data() {
    return {}
  },
  computed: {
    unClickDetailMode() {
      console.debug('this.currThemeObj:', this.currThemeObj)
      let flag = false
      if (['FIBAWA', 'FIBAMA'].includes(this.currThemeObj.moduleRouteNameEn)) {
        flag = true //不可点击进入详情
      }
      return flag
    },
  },
  methods: {
    clickPublish(mode, themeItem) {
      console.debug(themeItem)
      this.$emit('clickPublishEvent', {
        mode,
        themeItem,
      })
    },
    goDetail(item, mode) {
      console.debug(item, mode)
      if (this.unClickDetailMode) return
      if (mode == 'overviewPlayerData') {
        this.pageJump(
          this.$router,
          `playerDetailIndex_${this.currThemeObj.moduleRouteNameEn}`,
          {
            cid: this.currCid,
            sid: this.currSid,
            tid: item.teamId,
            pid: item.playerId,
          }
        )
      } else if (['overviewTeamData', 'teamData'].includes(mode)) {
        this.$localStorage.setItem(
          'mixtmt_teamDetail',
          JSON.stringify({
            teamName: item.shortName,
            teamLogo: item.imageUrl,
            teamId: item.id,
          })
        )
        this.pageJump(
          this.$router,
          `teamDetailIndex_${this.currThemeObj.moduleRouteNameEn}`,
          {
            cid: this.currCid,
            sid: this.currSid,
            tid: item.id,
          }
        )
      } else {
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.football_cup_cardList {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
  .card_item {
    margin: 1.38vw 1.38vw 0 0;
    width: calc((100% - (1.38vw * 3)) / 4);
    height: auto;
    overflow: auto;
    &:nth-child(4n) {
      margin: 1.38vw 0 0 0;
    }
    .cardItem_topBg {
      display: block;
      width: 100%;
      height: 0.42vw;
      background-color: var(--mixtmt_mainColor6);
    }
    .cardItem_main {
      position: relative;
      display: block;
      border: 1px solid var(--mixtmt_greyColor7);
      border-top: none;
      height: auto;
      color: var(--mixtmt_greyColor3);
      .cardItem_main_title {
        display: block;
        width: 100%;
        height: 4.166vw;
        padding: 0 1.388vw;
        line-height: 4.166vw;
        font-size: 1.25vw;
        font-weight: bold;
      }
      .theme_publishBtn {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 10;
        width: 3.2vw;
        height: 4.166vw;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        svg.publishBtn_icon {
          fill: var(--mixtmt_greyColor2);
        }
      }
      .cardItem_row_player_wrap {
        width: 100%;
        max-height: calc(16.65vw + 5px);
        overflow-y: auto;
      }
      .cardItem_row {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 2.083vw;
        width: 100%;
        height: calc(3.33vw + 1px);
        border-top: 1px solid var(--mixtmt_greyColor8);
        .cardItem_row_image {
          width: 2.083vw;
          height: 2.083vw;
          &.cardItem_row_player_image {
            width: 2.68vw;
            height: 2.68vw;
            .noImage {
              width: 100%;
              height: 100%;
              background-color: #efefef;
            }
          }
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .cardItem_row_text {
          width: calc(100% - 2.083vw);
          padding-left: 0.833vw;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          font-size: 0.972vw;
        }
        &.overviewTeamData,
        &.overviewPlayerData {
          padding: 0 0.694vw;
          .rankNo {
            width: 1.388vw;
            font-size: 0.972vw;
            text-align: center;
          }
          .cardItem_row_center {
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: flex-start;
            flex-direction: column;
            width: calc(100% - 1.388vw - 2.083vw - 5vw);
            .cardItem_row_name {
              width: 100%;
              padding-left: 0.833vw;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              font-size: 0.972vw;
              font-weight: bold;
            }
            .cardItem_row_teamName {
              width: 100%;
              padding-left: 0.833vw;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              font-size: 0.833vw;
              color: var(--mixtmt_greyColor4);
            }
          }
          .cardItem_row_name {
            width: calc(100% - 1.388vw - 2.083vw - 5vw);
            padding-left: 0.833vw;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            font-size: 0.972vw;
          }
          .cardItem_row_val {
            width: 5vw;
            text-align: right;
            padding-left: 0.833vw;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            font-size: 0.972vw;
          }
        }
        &.overviewTeamData {
          .cardItem_row_name {
            width: calc(100% - 1.388vw - 2.083vw - 6.94vw);
          }
          .cardItem_row_val {
            width: 6.94vw;
            padding-left: 0;
          }
        }
      }
    }
  }
}

.mixtmt_pc .football_cup_cardList:not(.unClickDetail) {
  .card_item {
    .cardItem_main {
      .theme_publishBtn {
        cursor: pointer;
        &:hover {
          svg.publishBtn_icon {
            fill: var(--mixtmt_subColor1_1);
          }
        }
      }
      .cardItem_row {
        cursor: pointer;
        &:hover {
          background-color: var(--mixtmt_subColor1_1);
          color: var(--mixtmt_whiteColor);
          .cardItem_row_center {
            .cardItem_row_teamName {
              color: var(--mixtmt_whiteColor);
            }
          }
        }
      }
    }
  }
}
</style>
